import React from 'react';
import moment from 'moment';
import { useObservableState } from 'observable-hooks';
import { map } from 'rxjs/operators';
import { useParams } from 'react-router-dom';
import {
  INTERNAL_EVENTS_EDIT,
  INTERNAL_EVENTS_INDEX,
} from '../../../router/routes';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';
import Event from '../../../interfaces/event';
import Form from '../../../components/form';
import Link from '../../../components/form/elements/link';
import useEventForm from './use-event-form';

export default function ViewEvent() {
  const { id } = useParams<{ id: string }>();
  const { eventService } = useService();
  const [event] = useObservableState<Event>(
    () =>
      eventService.show(id).pipe(
        map((event) => {
          return {
            ...event,
            time: moment.utc(event.time),
            created_at: moment(event.created_at).format('DD.MM.YYYY'),
          };
        })
      ),
    null
  );
  const body = useEventForm();
  const footer = [
    Link(route(INTERNAL_EVENTS_EDIT, { id: event?.id }), 'edit', true),
  ];

  return (
    <Form
      title={event ? event.title : null}
      backTo={INTERNAL_EVENTS_INDEX}
      mode={'view'}
      body={body}
      footer={footer}
      values={event}
      noticeAccessor="ViewForm"
    />
  );
}
